// extracted by mini-css-extract-plugin
export var title = "styles-module__title___bkBFs";
export var section = "styles-module__section___nefNN";
export var label = "styles-module__label___xz5xq";
export var dataSection = "styles-module__dataSection___zgMoI";